import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { withStyles } from '@material-ui/core/styles';
import Typography from '@material-ui/core/Typography';

const styles = () => ({
  typography: {
    display: 'inline-block',
    textTransform: 'capitalize',
    '&:first-child': {
      marginRight: 20,
    },
  },
});

const FacilitiesListItemSchedule = ({ schedule, classes }) => (
  <Fragment>
    {schedule.map(item => (
      <Typography
        key={item.ID}
        component="div"
        gutterBottom
      >
        <Typography
          className={classes.typography}
        >
          {item.Weekday.map(weekdayItem => weekdayItem.Slug).join(', ')}
        </Typography>
        <Typography
          className={classes.typography}
        >
          {`${item.From}-${item.To}`}
        </Typography>
      </Typography>
    ))}
  </Fragment>
);

FacilitiesListItemSchedule.propTypes = {
  schedule: PropTypes.arrayOf(PropTypes.shape({
    ID: PropTypes.number,
  })),
  classes: PropTypes.shape({
    typography: PropTypes.string.isRequired,
  }).isRequired,
};

FacilitiesListItemSchedule.defaultProps = {
  schedule: [],
};

export default withStyles(styles)(FacilitiesListItemSchedule);



// WEBPACK FOOTER //
// ./src/components/settings/FacilitiesList/FacilitiesListItemSchedule.js